import React, { useState } from 'react'

import { FormGroup } from 'shared/bootstrap/form/FormGroup'
import { InputAutocomplete } from 'shared/bootstrap/form/InputAutocomplete'
import { InputSelect } from 'shared/bootstrap/form/InputSelect'
import { InputSelectItem } from 'shared/bootstrap/form/InputSelectItem'
import { InputDateRange } from 'shared/form/InputDateRange'
import { ClientDataSource, ProviderDataSource } from 'shared/hooks/source'
import { Button } from 'shared/ui/button/Button'

import classes from './DeliverableListFilter.module.scss'

interface DeliverableListFilterProps {
  filter?: object
  onChange?: (_: object) => void
}

export const DeliverableListFilter: React.FC<DeliverableListFilterProps> = ({ filter, onChange }) => {
  const [value, setValue] = useState<object>(filter || {})
  const handleChange = (key: string) => (value: string | number | [string, string]) => {
    setValue(current => ({ ...current, [key]: value }))
  }
  return (
    <div className={classes.container}>
      <FormGroup label="Fornecedor">
        <ProviderDataSource>
          <InputAutocomplete placeholder="Todos" onChange={handleChange('session.provider_id')} />
        </ProviderDataSource>
      </FormGroup>
      <FormGroup label="Data do ensaio">
        <InputDateRange initial={[undefined, new Date()]} onChange={handleChange('session.scheduled_for')} />
      </FormGroup>
      {/*<FormGroup label="Data de entrega">
        <InputDateRange onChange={handleDateChange('delivered_at')} />
      </FormGroup>*/}
      <FormGroup label="Entregável">
        <InputSelect onChange={handleChange('item_id')}>
          <InputSelectItem value={6}>Fotos Tour 3D</InputSelectItem>
          <InputSelectItem value={9}>Fotos DSLR</InputSelectItem>
          <InputSelectItem value={10}>Vídeos</InputSelectItem>
          <InputSelectItem value={11}>Plantas</InputSelectItem>
        </InputSelect>
      </FormGroup>
      <FormGroup label="Status">
        <InputSelect onChange={handleChange('status')}>
          <InputSelectItem value={2}>Pendente</InputSelectItem>
          <InputSelectItem value={3}>Entregue</InputSelectItem>
        </InputSelect>
      </FormGroup>
      <FormGroup label="Cliente">
        <ClientDataSource>
          <InputAutocomplete placeholder="Todos" onChange={handleChange('session.client_id')} />
        </ClientDataSource>
      </FormGroup>
      <Button className={classes.button} type="button" onClick={() => onChange?.(value)}>
        BUSCAR
      </Button>
    </div>
  )
}
